export default class AlphaColor {
  color;
  opacity;
  constructor(color) {
    this.color = color;
    this.opacity = 1;
  }
  parseAlphaColor() {
    const match = this.color.match(/rgba?\(([^)]+)\)/);
    if (match) {
      const [r, g, b, a] = match[1].split(",").map(Number);
      this.color = `rgb(${r}, ${g}, ${b})`;
      this.opacity = a !== void 0 ? a : 1;
    }
    return this;
  }
}
